import { g as r } from "./index.esm-G8KyR0tM.js";
import { r as o } from "./jwt-decode.esm-kZY1eG1f.js";
var t = o();
const a = /* @__PURE__ */ r(t);
export {
  a as C,
  t as c
};
